import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchIconLabel: {
		id: 'servicedesk-insight-rapid-search-bar.trigger.search-icon-label',
		defaultMessage: 'Search icon label',
		description: 'Search icon label',
	},
});
